module.exports = __webpack_public_path__ + "static/media/winter_01.eaa207b1.jpg";